import { h } from 'preact';
import * as BaseComp from 'components/bolt/header/header.js';
import UarHeader from 'components/bolt/uarHeader/uarHeader.js';
import { accessNested, joinClasses } from 'utils/utils';
import { findInVNode } from 'utils/vnode';
import s from 'components/bolt/header/header.sss';
import sSocials from 'components/bolt/socials/socials.sss';

import Logo from 'components/bolt/uarHeader/components/logo/logo';
import Socials from 'components/bolt/uarHeader/components/socials/socials';

export default class Header extends BaseComp.default {

	render(props) {
		const base = super.render(props);
		const uarHeader = props?.appData?.header?.uarHeader;
		const isDesktopSize = props?.client?.isDesktopSize || false;

		if (uarHeader && isDesktopSize) {
			base.children.splice(0, 0, <UarHeader data={uarHeader} />);
			const defaultHeader = findInVNode(base, `.${s.container}`);
			if (defaultHeader) {
				defaultHeader.attributes.style.top = '134px';
			}
		}

		const headerData = this.props.headerData || {};


		if (uarHeader && !isDesktopSize) {
			const defaultHeader = findInVNode(base, `.${s.container}`);
			defaultHeader.attributes.class += ` ${s.mobileUarHeader}`;
			defaultHeader.children.splice(0, 0, <Socials data={uarHeader} extraClass={s.socials}  />);
			defaultHeader.children.splice(0, 0, <Logo data={uarHeader} extraClass={s.logo2} />);
		}
		return base;
	}
}
